module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://seed-static.seedasdan.com/wordpress/2024/09/aseeder-logo-new.png?x-oss-process=image/resize,m_fill,w_160,h_48"
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "mt-20 text-right",
    attrs: {
      "span": 18
    }
  }, [(this.Role != 'admin') ? _c('el-badge', {
    staticClass: "mr-40",
    attrs: {
      "value": _vm.NotificationCount
    }
  }, [_c('router-link', {
    staticClass: "dark",
    attrs: {
      "to": "/notification",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "el-icon-message"
  })])], 1) : _vm._e(), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    },
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n                        Hello " + _vm._s(_vm.LoginName) + " "), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [(this.Role == 'student') ? _c('el-dropdown-item', {
    staticClass: "font-eeSmall",
    attrs: {
      "command": "password"
    }
  }, [_c('i', {
    staticClass: "icon ion-unlocked mr-10"
  }), _vm._v(" Change Password\n                            ")]) : _vm._e(), _vm._v(" "), _c('el-dropdown-item', {
    staticClass: "font-eeSmall",
    attrs: {
      "command": "logout"
    }
  }, [_c('i', {
    staticClass: "icon ion-log-out mr-10"
  }), _vm._v("\n                                Log out\n                            ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Change Password",
      "visible": _vm.changePassDialog,
      "customClass": "dialogStyle"
    },
    on: {
      "update:visible": function($event) {
        _vm.changePassDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "passform",
    attrs: {
      "model": _vm.passform,
      "rules": _vm.changePassRules,
      "label-width": "145px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Current Password",
      "prop": "oldPwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.passform.oldPwd),
      callback: function($$v) {
        _vm.$set(_vm.passform, "oldPwd", $$v)
      },
      expression: "passform.oldPwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "New Password",
      "prop": "newPwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.passform.newPwd),
      callback: function($$v) {
        _vm.$set(_vm.passform, "newPwd", $$v)
      },
      expression: "passform.newPwd"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.changePassDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.changeSaveBtnIsLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitPass('passform')
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit User",
      "visible": _vm.editDialog,
      "customClass": "dialogStyle"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.profileLoading),
      expression: "profileLoading"
    }],
    ref: "editform",
    attrs: {
      "model": _vm.editform,
      "rules": _vm.editrules,
      "label-width": "145px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email Address",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email Address"
    },
    model: {
      value: (_vm.editform.email),
      callback: function($$v) {
        _vm.$set(_vm.editform, "email", $$v)
      },
      expression: "editform.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Given Name",
      "prop": "givenName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Given Name"
    },
    model: {
      value: (_vm.editform.givenName),
      callback: function($$v) {
        _vm.$set(_vm.editform, "givenName", $$v)
      },
      expression: "editform.givenName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Family Name",
      "prop": "familyName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Family Name"
    },
    model: {
      value: (_vm.editform.familyName),
      callback: function($$v) {
        _vm.$set(_vm.editform, "familyName", $$v)
      },
      expression: "editform.familyName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Display Name",
      "prop": "displayName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Display Name"
    },
    model: {
      value: (_vm.editform.displayName),
      callback: function($$v) {
        _vm.$set(_vm.editform, "displayName", $$v)
      },
      expression: "editform.displayName"
    }
  })], 1), _vm._v(" "), (this.Role === 'student') ? _c('el-form-item', {
    attrs: {
      "label": "Affiliation",
      "prop": "school"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Affiliation"
    },
    model: {
      value: (_vm.editform.school),
      callback: function($$v) {
        _vm.$set(_vm.editform, "school", $$v)
      },
      expression: "editform.school"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mobile Phone",
      "prop": "mobilePhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Mobile Phone"
    },
    model: {
      value: (_vm.editform.mobilePhone),
      callback: function($$v) {
        _vm.$set(_vm.editform, "mobilePhone", $$v)
      },
      expression: "editform.mobilePhone"
    }
  })], 1), _vm._v(" "), (this.Role == 'student') ? _c('el-form-item', {
    attrs: {
      "label": "Father Phone",
      "prop": "fatherPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Father Phone"
    },
    model: {
      value: (_vm.editform.fatherPhone),
      callback: function($$v) {
        _vm.$set(_vm.editform, "fatherPhone", $$v)
      },
      expression: "editform.fatherPhone"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.Role == 'student') ? _c('el-form-item', {
    attrs: {
      "label": "Mother Phone",
      "prop": "motherPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Mother Phone"
    },
    model: {
      value: (_vm.editform.motherPhone),
      callback: function($$v) {
        _vm.$set(_vm.editform, "motherPhone", $$v)
      },
      expression: "editform.motherPhone"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editSaveBtnIsLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitedit('editform')
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5db7c914"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/Header.vue
// module id = 616
// module chunks = 1